<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      {{ user.bonus }} Бонусов <v-btn class="ml-3" outlined @click="dialog = true">Начислить</v-btn>
    </v-col>
    <v-col cols="12">
      <v-data-table
              no-data-text="Нету модификаторов"
              :headers="headers"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :items="user.bonus_history"
              :footer-props="footerProps"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка модификаторов... Подождите пожалуйста"
      >
      </v-data-table>
    </v-col>
    <v-dialog
            v-model="dialog"
            max-width="445"
    >
      <v-card>
        <v-card-title class="headline">
          Начислить бонусы
        </v-card-title>

        <v-card-text>
          <v-text-field
            outlined
            v-model="chargeItem.count"
            label="Количество"
          ></v-text-field>
          <v-textarea
                  outlined
                  v-model="chargeItem.description"
                  label="Описание"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn
                  :loading="loadingButton"
                  @click="charge(); dialog = false"
          >
            Начислить
          </v-btn>
          <v-btn
                  outlined
                  :loading="loadingButton"
                  @click="dialog = false"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src


    import UserService from "../../../api/UserService";

    export default {
        name: 'Bonus',
        props: {
            value: Object,
            loading: Boolean,
            disabled: Boolean
        },
        data() {
            return {
                loadingButton: false,
                chargeItem: {
                  description: '',
                  count: 0
                },
                dialog: false,
                user: this.value,
                footerProps: {
                    itemsPerPageText: 'Модификаторов на страницу',
                    pageText: '',
                    itemsPerPageAllText: 'Все',
                    itemsPerPageOptions: [-1]
                },
                headers: [
                    {
                        text: 'Дата / время',
                        value: 'created_at',
                        sortable: false,
                    },
                    {
                        text: 'Описание',
                        value: 'description',
                        sortable: false,
                    },
                    {
                        text: 'Бонусы',
                        value: 'bonus_count',
                        sortable: false,
                    },
                ],
            }
        },
        mounted() {
        },
        watch: {},
        methods: {
          charge() {
            this.loadingButton = true
            UserService.chargeBonus(this.user.id, this.chargeItem).then(response => {
              this.user = response.data
              this.chargeItem.count = 0;
              this.chargeItem.description = '';
              this.loadingButton = false
              this.dialog = false
            });
          }
        }
    }
</script>

<style lang="scss">
  .category-svg{
    svg{
      width: 37px;
      height: 37px;
      path{
        stroke: #000
      }
    }
  }
  .grouped-row{
    background: #FAFCFF;
  }

</style>

<style lang="scss">
  .grouped-row {
    background: #FAFCFF;
  }

  .table-input {
    .v-input {
      height: 40px;
    }
  }
</style>
<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
